"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var core_api_shared_service_1 = require("../core-api-shared.service");
var core_api_client_config_1 = require("../../core-api-client.config");
var VideoArticleService = /** @class */ (function () {
    /**
     * Initialises a new instance of the VideoArticleService /> class.
     * @param http
     * @param config
     */
    function VideoArticleService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * Add Photo.
     * @param id
     * @param photo
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.AddPhoto = function (id, photo) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/" + id + "/addphoto", photo)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Get Actions.
     * @param id
     * @param profileId
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.GetActions = function (id, profileId) {
        return this.http.get(this.config.CoreApiURL + "/api/videoarticle/" + id + "/actions")
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Get Assignations.
     * @param id
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.GetAssignations = function (id) {
        return this.http.get(this.config.CoreApiURL + "/api/videoarticle/" + id + "/assignations")
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Can Edit Article.
     * @param id
     * @param profileId
     * @param canEditSectionArticles
     * @param canEditAnyArticle
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.CanEditArticle = function (id, profileId, canEditSectionArticles, canEditAnyArticle) {
        return this.http.get(this.config.CoreApiURL + "/api/videoarticle/" + id + "/canEdit")
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Create Editing Version.
     * @param id
     * @param value
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.CreateEditingVersion = function (id, value) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/" + id + "/editingversion", value)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Create Revision Version.
     * @param id
     * @param value
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.CreateRevisionVersion = function (id, value) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/" + id + "/revisionversion", value)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Create Final Draft Version.
     * @param id
     * @param value
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.CreateFinalDraftVersion = function (id, value) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/" + id + "/finaldraftversion", value)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Create Approval Version.
     * @param id
     * @param value
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.CreateApprovalVersion = function (id, value) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/" + id + "/approvalversion", value)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Create Live Version.
     * @param id
     * @param value
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.CreateLiveVersion = function (id, value) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/" + id + "/liveversion", value)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Delete Version.
     * @param id
     * @param value
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.DeleteVersion = function (id, value) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/" + id + "/deleteversion", value)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Get.
     * @param id
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.Get = function (id) {
        return this.http.get(this.config.CoreApiURL + "/api/videoarticle/" + id)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Get Updatable.
     * @param id
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.GetUpdatable = function (id) {
        return this.http.get(this.config.CoreApiURL + "/api/videoarticle/" + id + "/updatable")
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Restore Version.
     * @param id
     * @param value
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.RestoreVersion = function (id, value) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/" + id + "/restoreversion", value)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Create Async.
     * @param article
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.CreateAsync = function (article) {
        return this.http.post(this.config.CoreApiURL + "/api/videoarticle/", article)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Put.
     * @param id
     * @param article
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.Put = function (id, article) {
        return this.http.put(this.config.CoreApiURL + "/api/videoarticle/" + id, article)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Remove Photo.
     * @param id
     * @param imageId
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.RemovePhoto = function (id, imageId) {
        return this.http.delete(this.config.CoreApiURL + "/api/videoarticle/" + id + "/removephoto/" + imageId)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Update Photo.
     * @param id
     * @param photo
     * @returns An Observable containing boolean
     */
    VideoArticleService.prototype.UpdatePhoto = function (id, photo) {
        return this.http.put(this.config.CoreApiURL + "/api/videoarticle/" + id + "/updatephoto", photo)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    VideoArticleService = __decorate([ __param(1, core_1.Inject(core_api_client_config_1.CORE_API_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], VideoArticleService);
VideoArticleService.ɵfac = function VideoArticleService_Factory(t) { return new (t || VideoArticleService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(core_api_client_config_1.CORE_API_CLIENT_CONFIG)); };
VideoArticleService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: VideoArticleService, factory: function (t) { return VideoArticleService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VideoArticleService, [{
        type: core_1.Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [core_api_client_config_1.CORE_API_CLIENT_CONFIG]
            }] }]; }, null); })();
    return VideoArticleService;
}());
exports.VideoArticleService = VideoArticleService;

